var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 61H55.6366",
    stroke: "#0F4BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28.0138C2 25.2325 2 23.8419 2.88367 22.9778C3.76736 22.1138 5.1896 22.1138 8.03411 22.1138C10.8786 22.1138 12.3009 22.1138 13.1846 22.9778C14.0682 23.8419 14.0682 25.2325 14.0682 28.0138V45.7139C14.0682 48.4951 14.0682 49.8858 13.1846 50.7498C12.3009 51.6139 10.8786 51.6139 8.03411 51.6139C5.1896 51.6139 3.76736 51.6139 2.88367 50.7498C2 49.8858 2 48.4951 2 45.7139V28.0138Z",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4547 17.133C23.4547 14.4239 23.4547 13.0694 24.2402 12.2278C25.0257 11.3862 26.2899 11.3862 28.8184 11.3862C31.3468 11.3862 32.611 11.3862 33.3965 12.2278C34.182 13.0694 34.182 14.4239 34.182 17.133V45.8669C34.182 48.5759 34.182 49.9304 33.3965 50.772C32.611 51.6136 31.3468 51.6136 28.8184 51.6136C26.2899 51.6136 25.0257 51.6136 24.2402 50.772C23.4547 49.9304 23.4547 48.5759 23.4547 45.8669V17.133Z",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5682 7.83692C43.5682 5.08537 43.5682 3.7096 44.4519 2.85479C45.3356 2 46.7579 2 49.6024 2C52.4468 2 53.8691 2 54.7528 2.85479C55.6365 3.7096 55.6365 5.08537 55.6365 7.83692V45.7769C55.6365 48.5284 55.6365 49.9042 54.7528 50.759C53.8691 51.6138 52.4468 51.6138 49.6024 51.6138C46.7579 51.6138 45.3356 51.6138 44.4519 50.759C43.5682 49.9042 43.5682 48.5284 43.5682 45.7769V7.83692Z",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.58a23d6c3cab2911275edb05cf6a1598.svg";
export { ForwardRef as ReactComponent };